import { FC, Fragment, useEffect, useState } from "react";
import styled from "styled-components";
import { useOpenApiRequest, OpenApiRequestStatus } from "typescript-request-utils";
import { CustomerWithUserCustomers } from "../../../api/models/CustomerWithUserCustomers";
import { Organization } from "../../../api/models/Organization";
import NestedOrganizationCustomerView from "../../../framework/components/nestedView/NestedOrganizationCustomerView";
import { organizationsBothTabs, organizationsOneTab } from "../../../framework/components/table/nestedTableTabOptions";
import NestedTableTabSelection from "../../../framework/components/table/NestedTableTabSelection";
import { OpenedIcon, ClosedIcon } from "../../../framework/components/table/rowIcons";
import { TableRow, TableColumn, NestedTableIconButton, NestedTableRow } from "../../../framework/components/table/tableComponents";
import { getApiRegistry } from "../../../framework/state/apiRegistry";

export const LongTextTableColumn = styled.td`
    padding: 0 10px 0 10px;
    max-width: 200px;
    overflow: hidden;
`

const NameContainer = styled.div`
    display: flex;
`;

export interface OrganizationItemProps {
    organization: Organization;
    reloadOrganizations: () => void;
}

const OrganizationItem: FC<OrganizationItemProps> = (props) => {
    const [showNestedTable, setShowNestedTable] = useState<boolean>(false);
    const [activeTab, setActiveTab] = useState<string>('customerNumbers');
    const [customers, setCustomers] = useState<CustomerWithUserCustomers[]>();
    const [organizationCustomerRequest, loadOrganizationCustomers] = useOpenApiRequest(getApiRegistry().organizationsApi.getOrganizationCustomers);
    const [foundUserCustomers, setFoundUserCustomers] = useState<boolean>(false);

    useEffect(() => {
        loadOrganizationCustomers(props.organization.name);
        // eslint-disable-next-line
    }, [loadOrganizationCustomers]);

    useEffect(() => {
        if (organizationCustomerRequest.type === OpenApiRequestStatus.Complete) {
            setCustomers(organizationCustomerRequest.responsePayload);
        }
        // eslint-disable-next-line
    }, [organizationCustomerRequest]);

   useEffect(() => {
        if(customers){
            for (let customer of customers) {
                if(customer.userCustomers.length > 0){
                    setFoundUserCustomers(true)
                    break;
                }
            }
        }
        // eslint-disable-next-line
    }, [showNestedTable]);

    
    return (
        <Fragment>
            <TableRow theme={{ selected: showNestedTable }}>
                <TableColumn>
                    <NameContainer>
                        <NestedTableIconButton aria-labelledby="showNestedTableButton" id="showNestedTableButton" theme={{ selected: showNestedTable }} onClick={() => setShowNestedTable(!showNestedTable)}>
                            {showNestedTable ? <OpenedIcon /> : <ClosedIcon />}
                        </NestedTableIconButton>
                        {props.organization.name}
                    </NameContainer>
                </TableColumn>
                <LongTextTableColumn title={props.organization.description} style={{ flex: 1 }}> {props.organization.description} </LongTextTableColumn>
            </TableRow>
            {showNestedTable && organizationCustomerRequest.type === OpenApiRequestStatus.Complete && customers &&
                <Fragment>
                    <NestedTableRow>
                        <NestedTableTabSelection tabs={ foundUserCustomers ? organizationsBothTabs : organizationsOneTab} handleTabChange={setActiveTab} activeTab={activeTab} />
                    </NestedTableRow>
                    <NestedOrganizationCustomerView customers={customers} activeTab={activeTab}/>
                </Fragment>
            }
        </Fragment>
    )
}

export default OrganizationItem;